import streamFunctions from './stream/stream-functions'
import streamFactory from './stream/stream-factory'

module.exports = streamFactory({
  add: streamFunctions.add,
  addAll: streamFunctions.addAll,
  update: streamFunctions.updateBy('ownerId'),
})
